import { Component, Input } from '@angular/core';
import { Visit } from '../../../models/visit.model';
import { NeighborhoodService } from '../../../services/neighborhood.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VisitModalComponent } from '../../../components/visit-modal/visit-modal.component';

@Component({
  selector: 'app-passes-page',
  templateUrl: './passes-page.component.html',
  styleUrl: './passes-page.component.scss'
})
export class PassesPageComponent {

  @Input() visits: Visit[] = [];
  @Input() loading: boolean = false;

  constructor(
    private modalService: NgbModal,
    public neighborhoodService: NeighborhoodService,
  ) { }

  ngOnInit(): void {
    // console.log(this.visits);
  }

  /*
    ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
    ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  open(
    visit: Visit
  ) {
    const modalRef = this.modalService.open(
      VisitModalComponent,
      { size: 'lg' }
    );
    modalRef.componentInstance.visit = visit;
  }

}
